module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-view"
  }, [(_vm.iframeLink) ? _c('div', [_c('iframe', {
    attrs: {
      "frameborder": "0",
      "width": "100%",
      "height": _vm.height,
      "src": _vm.iframeLink,
      "allowfullscreen": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.mp4Link) ? _c('div', [_c('video-player', {
    attrs: {
      "src": _vm.mp4Link,
      "width": _vm.width,
      "height": _vm.height,
      "poster": _vm.poster
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26215b89"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/video-view/index.vue
// module id = 273
// module chunks = 107